import React from 'react';
import { Card, Row, Col, Button, Popconfirm, message } from 'antd';
import { onPost, api } from '../../../../core/api3';

class QuantRobotStrategyInteractionCard extends React.Component {

    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.getStrategyInteraction = this.getStrategyInteraction.bind(this);
    }

    onClick(type) {
        onPost(api.sendCommand.url, api.sendCommand.params(this.props.robotId, type)).then(response => {
            if (response === undefined) {
                return;
            }
            message.success('发送交互指令成功');
            this.loadData();
        });
    }

    getStrategyInteraction() {
        let rowlist = [];
        let rowSize = Math.ceil(this.props.strategyInteraction.length / 4);
        for (let i = 0; i < rowSize; i++) {
            rowlist.push([]);
        }
        this.props.strategyInteraction.forEach((data, index) => {
            rowlist[Math.floor(index / 4)].push(data);
        });
        return <Card title="策略交互" bordered={false}>
            {rowlist.map((row, index) => {
                return <Row gutter={20} key={'row_' + index} className={index === 0 ? '' : 'box-row'}>
                    {row.map((data, index2) => {
                        return <Col key={'col_' + index + '_' + index2} span="6" push="0">
                            <span>{data.describe}：</span>
                            <Popconfirm title={'确定要发送交互指令【' + data.value + '】？'} okText="确定" cancelText="取消" onConfirm={() => this.onClick(data.key)}>
                                <Button type="primary" disabled={this.props.status !== 1}>{data.value}</Button>
                            </Popconfirm>
                        </Col>
                    })}
                </Row>
            })}
        </Card>
    }

    render() {
        return (
            <div>
                {this.getStrategyInteraction()}
            </div>
        );
    }

}

export default QuantRobotStrategyInteractionCard;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/quant/QuantRobotStrategyInteractionCard.jsx